export default {"src":"https://fishbrain.com/_next/static/media/arrow.06e2614b.svg","height":513,"width":513,"blurWidth":0,"blurHeight":0};